import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from "./rootReducer";

const options = {
  immutableCheck: false,
  serializableCheck: false,
  thunk: true
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(options),
  devTools: process.env.NODE_ENV !== "production"
});

export default store;
